export const SelectionFilter = (data, key, isChecked, id = "userId") => {
  let oldData = GetSelectionData();
  if (!oldData) {
    SetInitialSelectionData();
  }

  if (data) {
    if (oldData && oldData.length > 0) {
      getUpdateOldData(key, isChecked, oldData, id, data);
    } else {
      SetSelectionData(
        keyCheckedFlag(key, "single", true) ? [data] : [...data]
      );
    }
  }
};

const keyCheckedFlag = (key, value, flag) => {
  return key === value && flag;
};

const SetInitialSelectionData = () => {
  localStorage.setItem("selectionFilter", JSON.stringify([]));
};

export const ClearSelectionData = () => {
  localStorage.removeItem("selectionFilter");
};

export const GetSelectionData = () => {
  let data = localStorage.getItem("selectionFilter")
    ? JSON.parse(localStorage.getItem("selectionFilter"))
    : null;
  return data;
};

const SetSelectionData = (data) => {
  localStorage.setItem("selectionFilter", JSON.stringify(data));
};

export const GetAllSelectedIds = (field) => {
  try {
    const data = localStorage.getItem("selectionFilter")
      ? JSON.parse(localStorage.getItem("selectionFilter"))
      : [];
    return data ? data.map((element) => element[field]) : [];
  } catch (e) {
    console.log(e);
    return [];
  }
};

export const GetSelectedColumns = (userTypeId) => {
  const columnTypeMap = {
    1: "admin",
    2: "admin",
    3: "distributor",
    4: "enterprise",
    5: "distInternalUser",
    6: "entInternalUser",
    7: "subscriber",
    8: "contents",
    9: "role",
    10: "catalog",
    11: "bundle",
    12: "listOfVendorDataColumns",
    13: "listOfContactDataColumns",
    14: "subscriberaccesscol",
  };

  const cols = localStorage.getItem("selectedColumns")
    ? JSON.parse(localStorage.getItem("selectedColumns"))
    : null;
  const columnType = columnTypeMap[userTypeId];
  return columnType ? getSelectedCols(cols, columnType) : [];
};
export const getSelectedCols = (cols, type) => {
  let selectedCols = [];
  if (!cols) return selectedCols;
  try {
    cols[type]?.forEach((el) => {
      if (el.isSelected && el.showInSelection && el.exportLabel)
        selectedCols.push(el.exportLabel);
    });
  } catch (e) {
    console.log(e);
  }

  return selectedCols;
};

function getUpdateOldData(key, isChecked, oldData, id, data) {
  if (keyCheckedFlag(key, "multiple", isChecked)) {
    const oldDataSetMultiple = new Set(oldData.map((d) => d[id]));
    const newData = data.filter((d) => !oldDataSetMultiple.has(d[id]));
    oldData = [...oldData, ...newData];
  } else if (keyCheckedFlag(key, "multiple", !isChecked)) {
    const removedDataMultiple = new Set(data.map((d) => d[id]));
    oldData = oldData.filter((el) => !removedDataMultiple.has(el[id]));
  } else if (keyCheckedFlag(key, "single", isChecked)) {
    const oldDataSetSingle = new Set(oldData.map((d) => d[id]));
    if (!oldDataSetSingle.has(data[id])) {
      oldData.push(data);
    }
  } else if (keyCheckedFlag(key, "single", !isChecked)) {
    oldData = oldData.filter((el) => el[id] !== data[id]);
  }
  SetSelectionData(oldData);
}
